interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    variant?: 'primary' | 'secondary';
}

export function Button({ variant = 'primary', className = '', children, ...props }: ButtonProps) {
    const base = 'rounded-lg px-5 py-2.5 text-sm font-semibold disabled:cursor-not-allowed';
    const variants = {
        primary: 'bg-green-600 text-white hover:bg-green-700 disabled:bg-gray-300',
        secondary: 'bg-white text-gray-700 border border-gray-300 hover:bg-gray-50 disabled:bg-gray-100',
    };

    return (
        <button className={`${base} ${variants[variant]} ${className}`} {...props}>
            {children}
        </button>
    );
}
